import { tokens } from "@manifesthhqinc/ui-library";
import styled from "styled-components";

export const NumberIconDiv = styled.div<{ $backgroundColor: string; $color: string; $inverted: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background-color: ${(props) => (props.$inverted ? "none" : props.$backgroundColor)};
  border: 1px solid ${(props) => props.$backgroundColor};

  span {
    font-weight: 500;
    font-size: 14px;
    line-height: 26px;
    text-align: center;
    color: ${(props) => (props.$inverted ? tokens.color.brand[700] : "#fff")};
  }
`;
